// styles.ts
import styled from 'styled-components'
import { ListItem } from '@mui/material'

interface StyledListItemProps {
  selected: boolean
}

const MenuContent = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 6px;
  overflow-y: auto;
  overflow-x: hidden;
  height: 100%;

  /* Hide scrollbar for Chrome, Safari and Opera */
  &::-webkit-scrollbar {
    display: none;
  }

  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
`

const StyledListItem = styled(ListItem)<StyledListItemProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1vh;
  margin-bottom: 6px;
  border-radius: 4px;
  background-color: ${({ selected }) => (selected ? 'var(--fill-accent-secondary-selected)' : 'transparent')};
  opacity: ${({ selected }) => (selected ? 1 : 1)};

  &:hover {
    background-color: var(--fill-accent-secondary-hover);
  }

  &.Mui-selected {
    background-color: var(--fill-accent-secondary-selected);
    &:hover {
      background-color: var(--fill-accent-secondary-hover);
    }
  }

  & .MuiListItemIcon-root {
    color: var(--content-neutral-primary);

    & .material-symbols-outlined {
      font-weight: 300;
      font-size: 20px;
      line-height: 100%;
    }
  }

  & .MuiListItemText-primary {
    color: var(--content-neutral-primary);
  }
`

export { MenuContent, StyledListItem }
